import { Box, Stack, useTheme, ShortText } from 'src/viewLayer/components/DesignSystem';

import { AnswersListContainer, AnswerContainer, AnswerCard } from './index.styled';
import { handleQuestionAnswered } from 'src/viewLayer/components/nodes/QuestionNode/handleQuestionAnswered';
import { getImageComponent } from 'src/viewLayer/assets/images';
import { t } from 'src/viewLayer/helpers/translations';
import { AnswersPropsType } from 'src/viewLayer/components/nodes/QuestionNode/types';
import { RadioInput } from 'src/viewLayer/components/shared/RadioInput/index.styled';

export const Answers = ({
  answersArray,
  clickHandlerProps,
  icons
}: AnswersPropsType): JSX.Element => {
  const theme = useTheme();
  return (
    <AnswersListContainer gap={8}>
      {
        answersArray.map((answer, index) =>
          <AnswerCard
            key={answer.i18n_key}
            id={`uat-${clickHandlerProps.name}-answer-${index}`}
            data-testid={`answer-${index}`}
            onClick={(): void => handleQuestionAnswered({ answer, index, ...clickHandlerProps })}
          >
            <AnswerContainer alignItems="center">
              { icons &&
                <Stack>
                  { getImageComponent(answer.icon_name || '', 24, theme.color.brand.default) }
                </Stack>
              }
              <Box padding={[8, 0, 8, 8]}>
                <ShortText>
                  { t(answer.i18n_key) }
                </ShortText>
              </Box>
              <RadioInput />
            </AnswerContainer>
          </AnswerCard>
        )
      }
    </AnswersListContainer>
  );
};
